/**
 * Centralized auth-token storage.
 *
 * SECURITY NOTE
 * -------------
 * Today the token is stored in localStorage. This is the lowest-risk place to
 * concentrate ALL token reads/writes so that a future migration to HttpOnly
 * cookies (or another secure mechanism) requires changing only this file.
 *
 * The canonical storage key is `ninja_token`. Earlier code referenced
 * `user_token` and `auth_token` — those were unwritten keys and caused
 * silently broken features (saved comparisons, gym reviews). All call-sites
 * now MUST use these helpers; never read/write the storage key directly.
 */

const STORAGE_KEY = 'ninja_token';

/** Browser-safe localStorage access (no-ops during SSR / non-DOM contexts). */
const storage = () => (typeof window === 'undefined' ? null : window.localStorage);

export function getAuthToken() {
  const s = storage();
  return s ? s.getItem(STORAGE_KEY) : null;
}

export function setAuthToken(token) {
  const s = storage();
  if (s && token) s.setItem(STORAGE_KEY, token);
}

export function clearAuthToken() {
  const s = storage();
  if (s) s.removeItem(STORAGE_KEY);
}

/** Convenience: returns the `Authorization` header object (or {} if not signed in). */
export function authHeader() {
  const t = getAuthToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export function isLoggedIn() {
  return Boolean(getAuthToken());
}
